import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { Store } from "@ngxs/store";
import { PROMPT_ERROR } from "@store/exception/error.action";
import { SalesManagementReportsService } from "@store/sales-management-reports/sales-management-reports.service";
import { Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { CampaignModel } from "src/app/shared/interfaces/administrator";
import {
  CHANGE_PREVIEW_CAMPAIGN,
  CREATE_CAMPAIGN,
  CREATE_CLUB_CAMPAIGN,
  EDIT_CAMPAIGN,
  GET_AGENTS_SUMMARY_LIST,
  GET_BDM_AGENT_LIST,
  GET_BRANCH_AGENT_LIST,
  GET_BRANCH_LIST,
  GET_CAMPAIGN,
  GET_CATEGORY_LOV,
  GET_CLUB_CAMPAIGN,
  GET_CURRENT_CAMPAIGN,
  GET_EXCEL_DOWNLOAD,
  GET_PAST_CAMPAIGN,
  GET_SEARCH_AGENTS_LIST,
  GET_UNTAGGED_AGENTS_LIST,
  PREVIEW_CAMPAIGN,
  RESET_CAMPAIGN,
  RETRIEVE_AGENTS_LIST,
  SAVE_AGENT_TAGGING,
  SET_CAMPAIGN_ARCHIVED,
  SET_CAMPAIGN_DETAILS,
  UPDATE_CAMPAIGN,
  UPDATE_CLUB_CAMPAIGN,
  UPLOAD_EXCEL_FILE,
  VALIDATE_CAMPAIGN_RANK,
} from "src/app/store/campaign/campaign.action";
import { SET_CONCURRENT_LOGIN_ERROR } from "src/app/store/login/login.action";
import { NAVIGATE_LOGIN_PAGE } from "src/app/store/user/user.action";

import { ProfileService } from "../profile/profile.service";
import { CampaignService } from "./campaign.service";
// import { branchList } from 'src/app/shared/data/report';

@State<CampaignModel>({
  name: "CampaignState",
  defaults: {
    createCampaign: null,
    branchList: null,
    campaignList: null,
    updateCampaign: null,
    uploadExcelFile: null,
    tempCampaignId: null,
    pastCampaignList: null,
    archivedCampaign: null,
    bdmAgentList: null,
    categoryLov: null,
    previewCampaign: null,
    branchAgentList: null,
    downloadExcel: null,
    editCampaign: null,
    campaignReqCategory: null,
    campaignReqCondition: null,
    campaignValCondition: null,
    untaggedAgentsList: null,
    validateCampaignRank: null,
    createClubCampaign: null,
    clubCampaignData: null,
    agentsSummaryList: null,
    retrieveAgentsList: null,
    campaignCommonLOV: null,
    agentTaggingResponse: null,
    searchAgentsList: null,
  },
})
@Injectable()
export class CampaignState {
  constructor(
    private readonly campaignService: CampaignService,
    private readonly store: Store,
    private readonly profileService: ProfileService,
    private readonly reportService: SalesManagementReportsService,
  ) {}

  @Selector()
  public static createCampaign(state: CampaignModel) {
    return state.createCampaign;
  }

  @Selector()
  public static previewCampaign(state: CampaignModel) {
    return state.previewCampaign ? state.previewCampaign : [];
  }

  @Selector()
  public static groupListing(state: CampaignModel) {
    return state.previewCampaign.groupList
      ? state.previewCampaign.groupList
      : [];
  }

  @Selector()
  public static previewAsDate(state: CampaignModel) {
    return state.previewCampaign.asDate ? state.previewCampaign.asDate : [];
  }

  @Selector()
  public static campaignResponseList(state: CampaignModel) {
    return state.campaignList ? state.campaignList : [];
  }

  @Selector()
  public static getCampaignId(state: CampaignModel) {
    return state.tempCampaignId;
  }

  @Selector()
  public static campaginLOV(state: CampaignModel) {
    return state.categoryLov ? state.categoryLov : [];
  }

  @Selector()
  public static campaignReqCategory(state: CampaignModel) {
    return state.campaignReqCategory ? state.campaignReqCategory : [];
  }

  @Selector()
  public static campaignReqCondition(state: CampaignModel) {
    return state.campaignReqCondition ? state.campaignReqCondition : [];
  }

  @Selector()
  public static campaignValCondition(state: CampaignModel) {
    return state.campaignValCondition ? state.campaignValCondition : [];
  }

  @Selector()
  public static untaggedAgentList(state: CampaignModel) {
    return state.untaggedAgentsList ? state.untaggedAgentsList : [];
  }

  @Action(SET_CAMPAIGN_DETAILS)
  public setCampaignDetails(
    { patchState }: StateContext<CampaignModel>,
    { payload }: SET_CAMPAIGN_DETAILS,
  ) {
    patchState({
      tempCampaignId: payload,
    });
  }

  @Selector()
  public static pastCampaignList(state: CampaignModel) {
    return state.pastCampaignList ? state.pastCampaignList : [];
  }

  @Selector()
  public static campaignArchived(state: CampaignModel) {
    return state.archivedCampaign;
  }

  @Action(CREATE_CAMPAIGN)
  public createCampaign(
    { patchState }: StateContext<CampaignModel>,
    { payload }: CREATE_CAMPAIGN,
  ) {
    return Observable.create((observable) => {
      const formData = new FormData();
      formData.append("file", payload.file);
      formData.append("campaign", JSON.stringify(payload.detail));
      const xhr = new XMLHttpRequest();

      xhr.onreadystatechange = () => {
        if (xhr.readyState !== 4) {
          return;
        }
        if (xhr.status === 200) {
          const data = JSON.parse(xhr.response);
          observable.next();

          patchState({
            createCampaign: {
              isSuccess: data.success,
              errorMsg: data.success ? null : data.error,
            },
          });
        } else {
          this.checkingErrorCode(xhr);
        }

        observable.complete();
      };
      xhr.open("POST", this.campaignService.createCampaign(), true);
      xhr.send(formData);
    });
  }

  @Action(CHANGE_PREVIEW_CAMPAIGN)
  public changePreviewCampagin(
    { patchState }: StateContext<CampaignModel>,
    { payload }: CHANGE_PREVIEW_CAMPAIGN,
  ) {
    return Observable.create((observer) => {
      // patchState({
      //   previewCampaign: {
      //     isSuccess: true,
      //     groupList: null,
      //     asDate: null,
      //   },
      // });
      const formData = new FormData();
      formData.append("file", payload.file);
      formData.append("campaign", JSON.stringify(payload.campagin));

      const xhr = new XMLHttpRequest();

      xhr.onreadystatechange = () => {
        if (xhr.readyState !== 4) {
          return;
        }
        if (xhr.status === 200) {
          let data = JSON.parse(xhr.response);
          observer.next(JSON.parse(xhr.response));

          patchState({
            previewCampaign: {
              isSuccess: data.isSuccess,
              errorMsg: null,
              groupList: data.groupList,
              asDate: {
                month: data.month,
                year: data.year,
              },
            },
          });
          observer.complete();
        } else {
          this.checkingErrorCode(xhr);
        }
      };
      xhr.open("POST", this.campaignService.previewCampagin(), true);
      xhr.send(formData);
    });
  }

  @Action(PREVIEW_CAMPAIGN)
  public previewCampagin(
    { patchState }: StateContext<CampaignModel>,
    { payload }: PREVIEW_CAMPAIGN,
  ) {
    return Observable.create((observer) => {
      const formData = new FormData();
      formData.append("file", payload.file);
      formData.append("campaign", JSON.stringify(payload.campagin));

      const xhr = new XMLHttpRequest();

      xhr.onreadystatechange = () => {
        if (xhr.readyState !== 4) {
          return;
        }
        if (xhr.status === 200) {
          let data = JSON.parse(xhr.response);
          observer.next(JSON.parse(xhr.response));

          patchState({
            previewCampaign: {
              isSuccess: data.success,
              errorMsg: data.success ? null : data.error,
              data: data,
              groupList: data.success ? data.groupList : null,
              asDate: {
                month: data.success ? data.month : null,
                year: data.success ? data.year : null,
              },
            },
          });
          observer.complete();
        } else {
          this.checkingErrorCode(xhr);
        }
      };
      xhr.open("POST", this.campaignService.previewCampagin(), true);
      xhr.send(formData);
    });
  }

  @Action(GET_CAMPAIGN)
  public getCampaignList(
    { patchState }: StateContext<CampaignModel>,
    { payload }: GET_CAMPAIGN,
  ) {
    return this.campaignService.getCampaignList(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            campaignList: res,
          });
        }
      }),
    );
  }

  @Action(GET_CURRENT_CAMPAIGN)
  public getCurrentCampaign(
    { patchState }: StateContext<CampaignModel>,
    { payload }: GET_CURRENT_CAMPAIGN,
  ) {
    return this.campaignService.getCampaignSummary(payload).pipe(
      map((res) => {
        patchState({
          campaignList: !res || res.error ? null : res,
        });
      }),
    );
  }

  @Action(GET_PAST_CAMPAIGN)
  public getPastCampaign(
    { patchState }: StateContext<CampaignModel>,
    { payload }: GET_PAST_CAMPAIGN,
  ) {
    return this.campaignService.getCampaignSummary(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            pastCampaignList: res,
          });
        }
      }),
    );
  }

  @Action(EDIT_CAMPAIGN)
  public editCampaignData(
    { patchState }: StateContext<CampaignModel>,
    { payload }: EDIT_CAMPAIGN,
  ) {
    return this.campaignService.editCampaign(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            editCampaign: {
              isUpdateCampaignSuccess: true,
              updateCampaignErrormsg: null,
              campaignResponse: res,
            },
          });
        } else {
          patchState({
            editCampaign: {
              isUpdateCampaignSuccess: false,
              updateCampaignErrormsg: res.error,
              campaignResponse: null,
            },
          });
        }
      }),
    );
  }

  @Action(UPDATE_CAMPAIGN)
  public updateEventAdmin(
    { patchState }: StateContext<CampaignModel>,
    { payload }: UPDATE_CAMPAIGN,
  ) {
    const formData = new FormData();
    formData.append("file", payload.file);
    formData.append("campaignId", payload.campaign);
    formData.append("updatedBy", payload.updatedBy);

    return Observable.create((observer) => {
      const xhr = new XMLHttpRequest();

      xhr.onreadystatechange = () => {
        if (xhr.readyState !== 4) {
          return;
        }
        if (xhr.status === 200) {
          let data = JSON.parse(xhr.response);
          patchState({
            updateCampaign: {
              isUpdateCampaignSuccess: data.success,
              updateCampaignErrormsg: data.success ? null : data.error,
            },
          });
          observer.next(JSON.parse(xhr.response));
          observer.complete();
        } else {
          this.checkingErrorCode(xhr);
        }
      };
      xhr.open("POST", this.campaignService.updateCampaign(), true);
      xhr.send(formData);
    });
  }

  @Action(UPLOAD_EXCEL_FILE)
  public uploadExcelFile(
    _ctx: StateContext<CampaignModel>,
    { payload }: UPLOAD_EXCEL_FILE,
  ) {
    const formData = new FormData();
    let detail = {
      firstName: "Peter",
      age: 201,
    };

    formData.append("file", payload.file);
    formData.append("detail", JSON.stringify(detail));
    const xhr = new XMLHttpRequest();

    xhr.onreadystatechange = () => {
      if (xhr.readyState !== 4) {
        return;
      }

      // if (xhr.status === 200) {
      // } else {
      // }
    };

    xhr.open("POST", this.campaignService.uploadExcelFile(), true);
    xhr.send(formData);
  }

  @Action(SET_CAMPAIGN_ARCHIVED)
  public setCampaignArchived(
    { patchState }: StateContext<CampaignModel>,
    { payload }: SET_CAMPAIGN_ARCHIVED,
  ) {
    return this.campaignService.setCampaignArchived(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            archivedCampaign: {
              isarchivedCampaignSuccess: true,
              campaignResponse: res,
              archivedCampaignErrormsg: null,
            },
          });
        } else {
          patchState({
            archivedCampaign: {
              isarchivedCampaignSuccess: false,
              archivedCampaignErrormsg: res.error,
              campaignResponse: null,
            },
          });
        }
      }),
    );
  }

  @Action(GET_BDM_AGENT_LIST)
  public getBdmAgentList(
    { patchState }: StateContext<CampaignModel>,
    { payload }: GET_BDM_AGENT_LIST,
  ) {
    return this.campaignService.getBdmAgentList(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            bdmAgentList: res,
          });
        }
      }),
    );
  }

  @Action(GET_CATEGORY_LOV)
  public getCampaignCategoryLov({ patchState }: StateContext<CampaignModel>) {
    return this.campaignService.getCampaignCategoryLov().pipe(
      map((res) => {
        if (res) {
          patchState({
            categoryLov: res.data ? res.data.CAMPAIGNCAT : [],
            campaignReqCategory: res.data ? res.data.CAMPAIGNREQCAT : [],
            campaignReqCondition: res.data ? res.data.CAMPAIGNREQCOND : [],
            campaignValCondition: res.data ? res.data.CAMPAIGNVALCOND : [],
            campaignCommonLOV: {
              statusList: res.data ? res.data.AGNSTAT : null,
              channelList: res.data ? res.data.CHANNEL : null,
              channelSatEvent: res.data ? res.data.CHANNELSATEVENT : null,
            },
          });
        }
      }),
    );
  }

  @Action(GET_EXCEL_DOWNLOAD)
  public getCampaignFile(
    { patchState }: StateContext<CampaignModel>,
    { payload }: GET_EXCEL_DOWNLOAD,
  ) {
    return this.campaignService.getCampaignFile(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            downloadExcel: res,
          });
        }
      }),
    );
  }

  @Action(GET_BRANCH_LIST)
  public getBranchList(
    { patchState }: StateContext<CampaignModel>,
    { payload }: GET_BRANCH_LIST,
  ) {
    return this.reportService.getReportsLov(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            branchList: res.data.BRANCH,
          });
        }
      }),
    );
  }

  @Action(GET_BRANCH_AGENT_LIST)
  public getBranchAgentList(
    { patchState }: StateContext<CampaignModel>,
    { payload }: GET_BRANCH_AGENT_LIST,
  ) {
    return this.profileService.getFilteredAgentList(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            branchAgentList: res.agentList,
          });
        }
      }),
    );
  }

  public checkingErrorCode(res) {
    const data = JSON.parse(res.response);

    const errorCodesList1 = [401, 403, 302, "401", "403", "302"];
    const errorCodesList2 = [500, 503, "500", "503"];

    if (res.status === 400) {
      this.store.dispatch(new SET_CONCURRENT_LOGIN_ERROR(data));
    }
    if (errorCodesList1.includes(res.status)) {
      if (data.isForcedLogout != null && data.isForcedLogout) {
        this.store.dispatch(new SET_CONCURRENT_LOGIN_ERROR(data));
      } else {
        this.store.dispatch(new NAVIGATE_LOGIN_PAGE());
      }
    }
    if (errorCodesList2.includes(res.status)) {
      this.store.dispatch(new PROMPT_ERROR(data));
    }
  }

  private deepCopy(object: object) {
    return JSON.parse(JSON.stringify(object));
  }

  @Action(VALIDATE_CAMPAIGN_RANK)
  public validateCampaignRank(
    { patchState }: StateContext<CampaignModel>,
    { payload }: VALIDATE_CAMPAIGN_RANK,
  ) {
    return Observable.create((observable) => {
      const formData = new FormData();
      // formData.append("file", payload.file);
      formData.append("clubCampaign", JSON.stringify(payload.detail));
      formData.append("rankNo", payload.rankNo);
      if (payload.file) {
        formData.append("badgeImage", payload.file);
      }
      const xhr = new XMLHttpRequest();

      xhr.onreadystatechange = () => {
        if (xhr.readyState !== 4) {
          return;
        }
        if (xhr.status === 200) {
          try {
            if (xhr.response) {
              const resData = JSON.parse(xhr.response);
              observable.next();
              if (resData.success) {
                patchState({
                  validateCampaignRank: {
                    isSuccess: resData.success,
                    errorMsg: null,
                    data: resData.data,
                  },
                });
              } else {
                patchState({
                  validateCampaignRank: {
                    isSuccess: resData.success,
                    errorMsg: resData.error,
                  },
                });
              }
            } else {
              console.error("Received empty response from server");
              observable.error("Received empty response from server");
            }
          } catch (error) {
            console.error("Error parsing response:", error);
            observable.error("Error parsing response");
          }
        } else {
          this.checkingErrorCode(xhr);
        }
        observable.complete();
      };
      xhr.open("POST", this.campaignService.validateCampaignRank(), true);
      xhr.send(formData);
    });
  }

  @Action(CREATE_CLUB_CAMPAIGN)
  public createClubCampaign(
    { patchState }: StateContext<CampaignModel>,
    { payload }: CREATE_CLUB_CAMPAIGN,
  ) {
    const userId = this.store.selectSnapshot<any>(
      (state) => state.UserState.user.userId,
    );
    const data = {
      ...payload,
      createdBy: userId,
    };
    return this.campaignService.createClubCampaign(data).pipe(
      map((res) => {
        if (res?.success) {
          // patchState({ })
          patchState({
            createClubCampaign: {
              data: res.data,
              isSuccess: res.success,
              message: res.message,
            },
          });
        } else {
          patchState({
            createClubCampaign: {
              isSuccess: res.success,
              errorMsg: res.error,
            },
          });
        }
      }),
    );
  }

  @Action(UPDATE_CLUB_CAMPAIGN)
  public updateClubCampaign(
    { patchState }: StateContext<CampaignModel>,
    { payload }: UPDATE_CLUB_CAMPAIGN,
  ) {
    const userId = this.store.selectSnapshot<any>(
      (state) => state.UserState.user.userId,
    );
    const data = {
      ...payload,
      updatedBy: userId,
    };
    return this.campaignService.updateClubCampaign(data).pipe(
      map((res) => {
        if (res?.success) {
          // patchState({ })
          patchState({
            createClubCampaign: {
              data: res.data,
              isSuccess: res.success,
              message: res.message,
            },
          });
        } else {
          patchState({
            createClubCampaign: {
              isSuccess: res.success,
              errorMsg: res.error,
            },
          });
        }
      }),
    );
  }

  @Action(GET_CLUB_CAMPAIGN)
  public getClubCampaign(
    { patchState }: StateContext<CampaignModel>,
    { payload }: GET_CLUB_CAMPAIGN,
  ) {
    return this.campaignService.getClubCampaign(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            clubCampaignData: res,
          });
        }
      }),
    );
  }

  @Action(RESET_CAMPAIGN)
  public resetCampaign({ patchState }: StateContext<CampaignModel>) {
    patchState({
      createClubCampaign: null,
      clubCampaignData: null,
      validateCampaignRank: null,
      agentTaggingResponse: null,
      retrieveAgentsList: null,
    });
  }

  @Action(GET_UNTAGGED_AGENTS_LIST)
  public getUntaggedAgentsList({ patchState }: StateContext<CampaignModel>) {
    return this.campaignService.getSearchUntaggedAgentsList().pipe(
      map((res) => {
        if (res?.data) {
          this.deepCopy(res.data);
          // let resData = [...res.data,...res.data,...res.data,...res.data];
          patchState({
            untaggedAgentsList: res.data,
          });
        }
      }),
      /* catchError((err) => {
        console.error('Error fetching untagged agents:', err);
        return of(null); // Return a default value or empty array
      }) */
    );
  }

  @Action(GET_AGENTS_SUMMARY_LIST)
  public getAgentsSummaryList({ patchState }: StateContext<CampaignModel>) {
    return this.campaignService.getAgentsSummaryList().pipe(
      map((res) => {
        if (res?.data) {
          // this.deepCopy(res.data);
          patchState({
            agentsSummaryList: res.data,
          });
        }
      }),
      catchError((err) => {
        console.error("Error fetching agents:", err);
        return of(null); // Return a default value or empty array
      }),
    );
  }

  @Action(RETRIEVE_AGENTS_LIST)
  public retrieveAgentsList(
    { patchState }: StateContext<CampaignModel>,
    { payload }: RETRIEVE_AGENTS_LIST,
  ) {
    return this.campaignService.getAgentsList(payload).pipe(
      map((res) => {
        if (res?.data) {
          const data = {
            ...res.data,
            isEdit: true,
          };
          patchState({
            retrieveAgentsList: data,
          });
        }
      }),
    );
  }

  @Action(SAVE_AGENT_TAGGING)
  public saveAgentTagging(
    { patchState }: StateContext<CampaignModel>,
    { payload }: SAVE_AGENT_TAGGING,
  ) {
    return this.campaignService.saveAgentTagging(payload).pipe(
      map((res) => {
        if (res) {
          patchState({
            agentTaggingResponse: res,
          });
        }
      }),
    );
  }

  @Action(GET_SEARCH_AGENTS_LIST)
  public getAgentsSearchList(
    { patchState }: StateContext<CampaignModel>,
    { payload }: GET_SEARCH_AGENTS_LIST,
  ) {
    return this.campaignService.getAgentsSearchList(payload).pipe(
      map((res) => {
        patchState({
          searchAgentsList: res.data,
          // campaignList: !res || res.error ? null : res
        });
      }),
    );
  }
}
